import { INavigationItem, useNavigationItemTransform, useNonCollateralNavItems } from '@cscglobal-tbs/nav-rail-ui';
import { useIsFeatureEnabled } from '../../api/features/features';
import { useGetNavigationItems } from '../../api/navigation/navigation';
import { getAnalyticsUrl } from '../../utils/EnvironmentUtils';

export const useNavigationData = () => {
    const { data: isAnalyticsPreviewEnabled, isLoading: isAnalyticsPreviewEnabledLoading } = useIsFeatureEnabled({
        featureFlagName: 'AnalyticsPreviewEnabled',
    });
    const { data: unfilteredNavItems, isLoading: isNavItemsLoading } = useGetNavigationItems();

    const nonCollateralItems = useNonCollateralNavItems({
        reviewAppUrl: '#',
        analyticsAppUrl: isAnalyticsPreviewEnabled ? getAnalyticsUrl(window.location.host) : '',
    });

    let navItems = (unfilteredNavItems as INavigationItem[]) || [];

    // Check if non-collateral items are already present in the backend response
    // For Modernized Navigation, the backend sends all items including non-collateral ones (may not send all non-collateral items, dependent on FF)
    // For earlier versions, the backend sends only collateral items and we need to add non-collateral ones manually
    const hasNonCollateralItems =
        nonCollateralItems.length > 0 &&
        nonCollateralItems.some((nonCollateralItem) =>
            navItems.some((navItem) => navItem.id === nonCollateralItem.id || navItem.displayName === nonCollateralItem.displayName)
        );

    const shouldAddNonCollateralItems = !hasNonCollateralItems && nonCollateralItems.length > 0;

    if (navItems.length > 0 && navItems[0].iconName === 'favorites') {
        navItems = navItems.slice(1);
        navItems[0].isFavorites = true;
    }

    if (shouldAddNonCollateralItems) {
        navItems = nonCollateralItems.concat(navItems);
    }

    const transformedNavItems = useNavigationItemTransform(navItems);

    // Find the calculation review navigation item and extract its GUID
    const calcReviewNavItem = transformedNavItems.find((item) => item.iconName?.toLowerCase() === 'calculationreview');
    const calcReviewPageId = calcReviewNavItem?.id;

    return {
        isNavItemsLoading: isNavItemsLoading || isAnalyticsPreviewEnabledLoading,
        transformedNavItems: transformedNavItems,
        calcReviewPageId,
    };
};
